import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { crearImpresoraRoutes, IMPRESION_DOCUMENTO, impresoraRoutesMap } from '../base/Impresora'

/** Pantalla propia de isi-rest: impresoras por artículo (comanda por área) */
const ListImpresoras = lazy(() => import('./view/ListImpresoras/ListImpresoras'))

export const impresorasRoutesMap = {
  ...impresoraRoutesMap,
  articulos: {
    path: '/impresoras/articulos',
    name: 'Impresoras por Artículo',
    action: 'GESTION_DE_IMPRESORAS',
  },
}

const impresorasRoutes = [
  ...crearImpresoraRoutes({
    documentos: [
      IMPRESION_DOCUMENTO.FACTURA,
      IMPRESION_DOCUMENTO.CAJA,
      IMPRESION_DOCUMENTO.COMANDA,
      IMPRESION_DOCUMENTO.RETIRO_CAJA,
      IMPRESION_DOCUMENTO.ESTADO_CUENTA,
    ],
  }),
  {
    path: impresorasRoutesMap.articulos.path,
    element: <ListImpresoras />,
    auth: authRoles.admin,
  },
]

export default impresorasRoutes
